import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { authenticationEnum } from '../components/shared/layout/menu-sidebar/menu-sidebar.component';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private jwtHelper: JwtHelperService) {}
  token = sessionStorage.getItem(authenticationEnum.token);

  getTokenClaims(token:string) {
    return this.jwtHelper.decodeToken(token);
  }

  isTokenExpired(){
    var token = sessionStorage.getItem(authenticationEnum.token);
    return this.jwtHelper.isTokenExpired(token);
  }

  getUserId(token:string) {
    return this.getTokenClaims(token).claims.UserId;
  }

  getAccountId(token:string){
    return this.getTokenClaims(token).claims.AccountId;
  }

  getRoles() {
    return this.getTokenClaims(this.token).claims.roles;
  }

  isAuthenticated(): boolean {
    return sessionStorage.getItem(authenticationEnum.loggedIn) != null && sessionStorage.getItem(authenticationEnum.loggedIn) == authenticationEnum.true &&
      sessionStorage.getItem(authenticationEnum.token) != null;
  }
}
